import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { principles } from '../../data/profile';
export function Principles() {
  const [featured, ...supporting] = principles;
  return <section aria-labelledby="principles" className="mt-24" data-id="element-351" data-mp="24rxm865qjf6o">
      <div id="principles" data-id="element-352" data-mp="28vluys63sgti">
        <SectionHeading label="Principles" title="How I work" data-id="element-353" data-mp="28vvnamemf02d" />
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-[1.55fr_1fr] md:items-stretch" data-id="element-354" data-mp="2duysq7yij8av">
        <Reveal className="h-full" data-id="element-355" data-mp="2it0cyw7oddnx">
          <article className="flex h-full flex-col justify-center rounded-[20px] bg-ink-deep px-7 py-8 md:px-8 md:py-10" data-id="element-356" data-mp="2iryysivd4b1z">
            <p className="text-[13px] font-semibold tabular-nums tracking-wide text-coral" data-id="element-357" data-mp="2nks1703cz7aw">{featured.number}</p>
            <span className="mt-2.5 w-fit rounded-full bg-coral-soft px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-fg" data-id="element-358" data-mp="2skw9w3y0yxqk">
              Core belief
            </span>
            <h3 className="mt-4 max-w-md text-[26px] font-semibold leading-[1.18] tracking-tight text-white md:text-[30px]" data-id="element-359" data-mp="31hos11jh8ors">
              {featured.title}
            </h3>
            <p className="mt-3.5 max-w-md text-[15px] leading-relaxed text-white/80" data-id="element-360" data-mp="30ukeduegjj6c">{featured.body}</p>
          </article>
        </Reveal>

        <div className="flex flex-col" data-id="element-361" data-mp="2vy3nisfviqpk">
          {supporting.map((p, i) => <Reveal key={p.number} delay={0.05 + i * 0.05} className="flex flex-1" data-id="element-362" data-mp="2qz0mdj30l4mv" data-mpi={i}>
              <div className={`flex flex-1 flex-col justify-center border-t border-line py-5 ${i === supporting.length - 1 ? 'border-b' : ''}`} data-id="element-363" data-mp="3okeqg9qyd3pj">
                <p className="text-xs font-semibold tabular-nums text-fg-faint" data-id="element-364" data-mp="3eta76xu8uwow">{p.number}</p>
                <h3 className="mt-1.5 text-[15px] font-semibold text-fg" data-id="element-365" data-mp="39vrz19o1wlhy">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-fg-muted" data-id="element-366" data-mp="b7mf1a54vh98">{p.body}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}